import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const restaurantAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRestaurant()) {
    return true;
  }
  router.navigate(['/dashboard/main']);
  return false;
};
